export default __webpack_public_path__ + "static/media/Job-Search.f233a04f.svg";